import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/shared/session.service';

/**
 * Guard to protect routes from unauthorized access.
 * 
 * This guard checks if a user session exists by verifying the presence of
 * a 'loggedInUser' in the session. If the user is authenticated, access is granted.
 * Otherwise, the user is redirected to the '/site-error' route.
 *
 * @remarks
 * This guard should be provided in the route configuration to secure routes
 * that require authentication.
 *
 * @example
 * {
 *   path: 'dashboard',
 *   canActivate: [AuthGuard],
 *   component: DashboardComponent
 * }
 *
 * @see {@link SessionService}
 * @see {@link Router}
 */
@Injectable()
export class AuthGuard {
  constructor(
    private _SessionService: SessionService,
    private _Router: Router,
  ) {}
  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this._SessionService.getSession('loggedInUser')) {
      return true;
    }
    this._Router.navigate(['/site-error']);
    return false;
  }
}
